import { useEffect } from "react";

export const usePreviewChannels = (data, setValue) => {
  useEffect(() => {
    if (!data) return;

    const channels = [];

    if (data.sms) channels.push("SMS");
    if (data.email) channels.push("Email");
    if (data.whatsapp) channels.push("WhatsApp");
    if (data.rcs) channels.push("RCS");

    setValue(channels);
  }, [data, setValue]);
};